import React from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import Header from "../Header";
import { useDispatch, useSelector } from "react-redux";
import { useIdleTimer } from "react-idle-timer";
import { setCommunityData } from "../../redux/actions/communityDetails";
import { showErrorMessage } from "../../components/core/errorHandling";

const PrivateComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector(
    (state) =>
      state.communityData && Object.keys(state.communityData).length > 0
  );

  const handleIdle = () => {
    dispatch(setCommunityData(null));
    showErrorMessage("Logged out", "Session Timed Out");
    localStorage.removeItem("communityData");
    navigate("/login");
  };

  useIdleTimer({
    timeout: 1800_000, // (30Minute)
    onIdle: handleIdle,
    debounce: 250, // Reduce frequent event calls
  });

  return isAuthenticated ? (
    <>
      <Header />
      <Outlet />
    </>
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateComponent;
